// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1460":"97949ed14a3093d1","3185":"11bc775ef9d68920","3289":"b3b2117c550a1173","3933":"3f5727d649e5eeba","8201":"a06bf2df40981c95"}[chunkId] + ".css";
};